import { useLingui } from '@lingui/react/macro';
import { Button } from '@utima/ui';
import { UserX } from 'lucide-react';
import { useState } from 'react';

import { SimpleTooltip } from '@/components';
import { ConfirmDialog } from '@/components/confirmDialog/ConfirmDialog';

interface RemoveUserDialogButtonProps {
  userId: string;
  organizationId: string;
  onRemove: (params: {
    userId: string;
    organizationId: string;
  }) => Promise<void>;
  disabled?: boolean;
}

export function RemoveUserDialogButton({
  userId,
  organizationId,
  onRemove,
  disabled,
}: RemoveUserDialogButtonProps) {
  const { t } = useLingui();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <ConfirmDialog
        open={isOpen}
        onConfirm={() => onRemove({ userId, organizationId })}
        onOpenChange={setIsOpen}
        description={t`Are you sure you want to remove this user from the organization?`}
      />
      <SimpleTooltip title={t`Remove from organization`}>
        <Button
          data-cta='admin-remove-user-dialog-button'
          onClick={() => setIsOpen(true)}
          disabled={disabled}
          variant='ghost'
          size='icon-xs'
          outline
          icon={<UserX className='size-4 text-danger' />}
        />
      </SimpleTooltip>
    </>
  );
}
